import { render, staticRenderFns } from "./ExpensesList.vue?vue&type=template&id=24dcd20d&scoped=true"
import script from "./ExpensesList.vue?vue&type=script&lang=ts"
export * from "./ExpensesList.vue?vue&type=script&lang=ts"
import style0 from "./ExpensesList.vue?vue&type=style&index=0&id=24dcd20d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dcd20d",
  null
  
)

export default component.exports